import React, { FC } from 'react';
import cx from 'classnames';

import './index.scss';

const segmentDark = (fill) => (
  <svg 
    width="75"
    height="75"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.2352 30.9949C17.6079 40.0667 21.6409 49.7299 30.5587 53.5732C31.6999 54.0649 32.0345 55.842 31.5427 56.9831C31.0508 58.1242 29.5368 59.1004 28.3957 58.6084C17.2444 53.8024 11.6104 40.3061 16.1455 28.9636C16.6068 27.8098 18.3788 27.4314 19.5327 27.8928C20.6865 28.3541 21.6965 29.841 21.2352 30.9949Z"
      fill={fill}
    />
  </svg>
);

const segmentLarge = (fill) => (
  <svg 
    width="75"
    height="75"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.6396 30.7589C16.9518 39.9822 21.5429 50.6564 30.7663 54.3441C34.3959 55.7954 38.3029 55.9947 41.8305 55.1243C43.0369 54.8262 44.2193 55.4171 44.517 56.6235C44.8148 57.8299 44.0462 58.9242 42.8398 59.2219C38.4306 60.3102 33.7382 60.0554 29.2047 58.2431C17.6736 53.6324 12.1294 40.7302 16.74 29.1991C17.2013 28.0452 18.3788 27.4314 19.5326 27.8928C20.6865 28.3541 21.101 29.605 20.6396 30.7589Z"
      fill={fill}
    />
  </svg>
);

const segmentMedium = (fill) => (
  <svg 
    width="75"
    height="75"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M57.03 31.6939C58.2529 31.4735 59.2544 32.3181 59.4749 33.5411C60.493 39.1916 59.3312 44.6209 56.549 49.1607C55.8999 50.2204 54.6517 50.6373 53.592 49.9878C52.5326 49.3387 52.3354 48.0366 52.9845 46.9772C55.2128 43.3409 56.175 38.8004 55.3601 34.2798C55.1396 33.0569 55.8067 31.9143 57.03 31.6939Z"
      fill={fill}
    />
  </svg>
);


const segmentSmall = (fill) => (
  <svg 
    width="75"
    height="75"
    viewBox="0 0 75 75"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M51.5872 22.7803C52.5405 21.9829 53.9595 22.1091 54.7568 23.0622C55.0159 23.3715 55.2638 23.6847 55.5019 24.0017C56.2481 24.9952 56.0479 26.4057 55.0545 27.1521C54.0607 27.8985 52.6504 27.6981 51.9041 26.7047C51.7117 26.4488 51.5126 26.1972 51.3056 25.9497C50.508 24.9967 50.6344 23.5777 51.5872 22.7803Z"
      fill={fill}
    />
  </svg>
);

interface ILoading {
  absolute?: boolean;
  zIndex?: number;
}

const Loading: FC<ILoading> = ({ absolute, zIndex, ...props }) => {
  return (
    <div
      className={cx('loading-indicator-container css-loader', { absolute })}
      style={{ zIndex: typeof zIndex === 'number' ? zIndex : 'initial' }}
      {...props}
    >
      <div className="segment medium">{segmentMedium("#82F0F2")}</div>
      <div className="segment small">{segmentSmall("#82F0F2")}</div>
      <div className="segment large">{segmentLarge("#82F0F2")}</div>
      <div className="segment dark">{segmentDark("#2D4277")}</div>
      <div className="segment dark-2">{segmentDark("#2D4277")}</div>
      <div className="segment small-2">{segmentSmall("#82F0F2")}</div>
    </div>
  );
}


export default Loading;
